const BBVA_SCRIPT = process.env.VUE_APP_BBVA_SCRIPT_URL;

if (BBVA_SCRIPT) {
  (function (p, u, s, h) {
    s = u.createElement('script'); s.type = 'text/javascript'; s.async = true;
    s.src = BBVA_SCRIPT
    h = u.getElementsByTagName('script')[0]; h.parentNode.insertBefore(s, h);
  }(window, document));
}
